import { AnswerColumn, AxisConfig, ChartViz } from '../generated/graphql-types';

export const updateAxisConfigColumns = (
    chartViz: ChartViz,
    overrides: Partial<AnswerColumn>,
) => {
    return chartViz.config.axisConfig.map((config: AxisConfig) => {
        const updatedConfig = { ...config };
        Object.keys(updatedConfig).forEach((key: keyof AxisConfig) => {
            if (Array.isArray(updatedConfig[key])) {
                (updatedConfig as any)[key] = updatedConfig[key].map(
                    (col: AnswerColumn) => {
                        if (col.id === overrides.id) {
                            return {
                                ...col,
                                ...overrides,
                            };
                        }
                        return col;
                    },
                );
            } else if (
                updatedConfig[key] &&
                (updatedConfig[key] as any).id === overrides.id
            ) {
                updatedConfig[key] = {
                    ...(updatedConfig as any)[key],
                    ...overrides,
                };
            }
        });
        return updatedConfig;
    });
};
